import { useCallback, useState } from 'react'
import { Input, Form, Alert } from 'antd'
import { isEmpty } from 'lodash'
import { Button, Drawer } from '@src/components'
import { useMountEffect } from '@src/hooks'
const { TextArea } = Input

export const EditFoundationDocumentDrawer = ({ cb, values, data, onClose, ...props }) => {
  const [formEdit] = Form.useForm(null)
  const [isError, setIsError] = useState()
  const [isBlockSaveBtn, setIsBlockSaveBtn] = useState(true)
  const handleSetBlockSaveBtn = useCallback(value => setIsBlockSaveBtn(value), [])
  const handleSetError = useCallback(value => setIsError(value), [])
  useMountEffect(() => {
    formEdit.setFieldsValue({ 'document_name': values.document_name, 'document_number': values.document_number })
  })

  function onChangeInput () {
    const name = formEdit.getFieldValue().document_name
    const number = formEdit.getFieldValue().document_number
    if(isEmpty(name) || isEmpty(number)) {
      handleSetBlockSaveBtn(true)
    } else {
      handleSetBlockSaveBtn(false)
      handleSetError()
    }
  }

  return <Drawer
    className='custom-modal'
    title='Редактирование документа-основания'
    width={560}
    onClose={onClose}
    destroyOnClose
    {...props}
    footer={<RecordModalFooter
      cb={cb}
      onClose={onClose}
      form={formEdit}
      values={values}
      data={data}
      handleSetError={handleSetError}
      isBlockSaveBtn={isBlockSaveBtn}
      handleSetBlockSaveBtn={handleSetBlockSaveBtn}
    />}
  >
    <Form
      name='DocumentFoundationEditForm'
      form={formEdit}
      layout='vertical'
    >
      <Form.Item name='document_name' label='Наименование регионального НПА'>
        <TextArea
          rows={4}
          placeholder='Введите'
          onChange={onChangeInput}
        />
      </Form.Item>
      <Form.Item name='document_number' label='Номер регионального НПА'>
        <Input
          placeholder='Введите'
          onChange={onChangeInput}
        />
      </Form.Item>
    </Form>
    {isError &&
      <Alert type='error' showIcon description={isError}></Alert>
    }
  </Drawer>
}

const RecordModalFooter = ({ cb, onClose, form, values, handleSetError, data, isBlockSaveBtn, handleSetBlockSaveBtn  }) => {
  function checkIsSuchData (values) {
    let result = true
    data.forEach((element) => {
      if((element.document_name === values.document_name
        || element.document_number === values.document_number) && element.uuid_code !== values.uuid_code) {
        result = false
      }
    })
    return result
  }
  const handleBtn = (e, val) => {
    if(!val) {
      onClose()
      return
    }
    const formValues = form.getFieldsValue()
    formValues.uuid_code = values.uuid_code
    if(isEmpty(formValues.document_name) || isEmpty(formValues.document_number)) {
      handleSetError('Поля обязательны для заполнения')
      handleSetBlockSaveBtn(true)
      return
    }
    if(checkIsSuchData(formValues)) {
      handleSetError()
      cb(val, formValues)
      onClose()
    } else {
      handleSetError('Такой НПА уже добавлен. Сохранение невозможно.')
      handleSetBlockSaveBtn(true)
    }
  }

  return <div
    className='buttons-wrapper'
    style={{ display: 'flex', justifyContent: 'right' }}
  >
    <Button
      className='mr-8'
      label='Отмена'
      onClick={e => handleBtn(e, false)}
    />
    <Button
      label='Сохранить'
      icon='check_cr_fr_white'
      onClick={e => handleBtn(e, true)}
      disabled={isBlockSaveBtn}
      isSuccess
    />
  </div>
}
